import { useState } from "react";
import { MessageCircle, Phone, MessageSquareText } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CONTACT } from "@/constants/contact";

// "Questions first?" — the number sits behind a small popup with Call (business hours) and Text.
export const QuestionsFirst = ({ testid = "about-phone-link" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={testid}
        className="flex items-center gap-2 font-display font-bold text-navy text-lg hover:text-terracotta transition-colors">
        <MessageCircle className="h-5 w-5 shrink-0" />
        <span className="whitespace-nowrap">Questions first?</span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid={`${testid}-popup`}>
          <DialogHeader className="text-left sm:text-left">
            <DialogTitle className="font-display text-2xl font-bold text-navy tracking-tight">Questions first?</DialogTitle>
            <DialogDescription>Happy to help — call or text me, Bryan.</DialogDescription>
          </DialogHeader>
          <p className="font-display text-3xl font-extrabold text-navy tracking-tight" data-testid={`${testid}-number`}>{CONTACT.phoneDisplay}</p>
          <div className="grid gap-2">
            <a href={CONTACT.phoneHref} data-testid={`${testid}-call`}
              className="flex items-center gap-3 min-h-[52px] px-4 bg-navy text-white font-semibold hover:bg-navy-deep transition-colors">
              <Phone className="h-5 w-5 shrink-0" />
              <span>Call during business hours<span className="block text-xs font-normal text-white/70">{CONTACT.hours}</span></span>
            </a>
            <a href={CONTACT.smsHref} data-testid={`${testid}-text`}
              className="flex items-center gap-3 min-h-[52px] px-4 border-2 border-terracotta text-terracotta font-semibold hover:bg-terracotta hover:text-white transition-colors">
              <MessageSquareText className="h-5 w-5 shrink-0" /> Text
            </a>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
